import { BaseModelJson } from "common/interfaces/BaseModelJson";
import {
	Comment2Json,
	CommentJson,
	FilterComment,
} from "features/comment/types/comment.type";
import BaseModel from "./BaseModel";
import { FileJson } from "common/types/File";

class CommentModel extends BaseModel implements BaseModelJson<CommentJson> {
	employee_id: number;
	id: number;
	customer_id: number;
	name: string;
	phone: number;
	email: string;
	images: FileJson[];
	detail: string;
	item_id: string;
	item_type: string;
	parent_id: number;
	has_child: number;
	rate: number;
	has_notify: number;
	has_replied: number;
	note: string;
	tag: number;
	type: number;
	like: number;
	dislike: number;
	status: number;
	isdeleted: number;
	date_created: number;
	date_modified: number;
	date_deleted: number;
	count_chill: number;
	title: string;

	constructor(json: CommentJson) {
		super();
		// this.stt = json.stt || 0;
		this.employee_id = json.employee_id || 0;
		this.id = json.id || 0;
		this.customer_id = json.customer_id || 0;
		this.name = json.name || "";
		this.phone = json.phone || 0;
		this.email = json.email || "";
		this.images = json.images || [];
		this.detail = json.detail || "";
		this.item_id = json.item_id || "";
		this.item_type = json.item_type || "";
		this.parent_id = json.parent_id || 0;
		this.has_child = json.has_child || 0;
		this.rate = json.rate || 1;
		this.has_notify = json.has_notify || 0;
		this.has_replied = json.has_replied || 0;
		this.note = json.note || "";
		this.tag = json.tag || 0;
		this.type = json.type || 0;
		this.like = json.like || 0;
		this.dislike = json.dislike || 0;
		this.status = json.status || 0;
		this.isdeleted = json.isdeleted || 0;
		this.date_created = json.date_created || 0;
		this.date_modified = json.date_modified || 0;
		this.date_deleted = json.date_deleted || 0;
		this.count_chill = json.count_chill || 0;
		this.title = json.title || "";
	}

	static getDefaultData(): CommentJson {
		return {
			employee_id: 0,
			id: 0,
			customer_id: 0,
			name: "",
			phone: 0,
			email: "",
			images: [],
			detail: "",
			item_id: "",
			item_type: "",
			parent_id: 0,
			has_child: 0,
			rate: 1,
			has_notify: 0,
			has_replied: 0,
			note: "",
			tag: 0,
			type: 0,
			like: 0,
			dislike: 0,
			status: 0,
			isdeleted: 0,
			date_created: 0,
			date_modified: 0,
			date_deleted: 0,
			count_chill: 0,
			title: "",
		};
	}
	static getDefaultFilter(): FilterComment {
		return {
			page: 1,
			limit: 5,
			sort_by: "date_created",
			sort_type: "DESC",
			keyword: "",
			status: 1,
			// customer_id: 0,
			item_id: "",
			item_type: "product",
			parent_id: 0,
			// onlyme: 0,
		};
	}
	static getDefaultQaReviewFilter(): FilterComment {
		return {
			page: 1,
			limit: 20,
			sort_by: "",
			sort_type: "",
			keyword: "",
			status: 0,
			// customer_id: 0,
			// item_id: "",
			// item_type: 0,
			// parent_id: 0,
		};
	}

	toJson(): CommentJson {
		return {
			employee_id: this.employee_id,
			id: this.id,
			customer_id: this.customer_id,
			name: this.name,
			phone: this.phone,
			email: this.email,
			images: this.images,
			detail: this.detail,
			item_id: this.item_id,
			item_type: this.item_type,
			parent_id: this.parent_id,
			has_child: this.has_child,
			rate: this.rate,
			has_notify: this.has_notify,
			has_replied: this.has_replied,
			note: this.note,
			tag: this.tag,
			type: this.type,
			like: this.like,
			dislike: this.dislike,
			status: this.status,
			isdeleted: this.isdeleted,
			date_created: this.date_created,
			date_modified: this.date_modified,
			date_deleted: this.date_deleted,
			count_chill: this.count_chill,
			title: this.title,
		};
	}
	// static getDefaultData(): Comment2Json {
	//   return {
	//     company_id: 0,
	//     employee_id: 0,
	//     leavetypes_id: 0,
	//     id: 0,
	//     dayoff: 0,
	//     datefrom: 0,
	//     dateto: 0,
	//     note: "",
	//     status: 0,
	//     date_created: 0,
	//     date_modified: 0,
	//   };
	// }
}

export default CommentModel;
